import { render, staticRenderFns } from "./cardV1.vue?vue&type=template&id=52f0ab76&scoped=true"
import script from "./cardV1.vue?vue&type=script&lang=js"
export * from "./cardV1.vue?vue&type=script&lang=js"
import style0 from "./cardV1.vue?vue&type=style&index=0&id=52f0ab76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f0ab76",
  null
  
)

export default component.exports